<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="col-lg-3">
      </div>
    </div>
    <div class="col-lg-12">
      <button class="btn btn-primary btn-xs" @click="showAddGeo = true"><i class="fa fa-plus"></i> Add</button>
      <table class="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>Countries</th>
            <th>T&C Text</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
        <tr v-if="showAddGeo">
          <td>
            <v-select :options="availableCountries" v-model="newGeo.countryCode" index="country_iso_code" label="location_name" placeholder="Country"></v-select>
          </td>
          <td>
            <input type="text" v-model="newGeo.termsCondition" class="form-control" >
          </td>
          <td>
            <button class="btn btn-primary btn-sm" @click="editGeo(newGeo)"><i class="fa fa-save"></i> Save</button>
            <button class="btn btn-danger btn-sm" @click="showAddGeo = false; $forceUpdate()"><i class="fa fa-remove"></i> Cancel</button>
          </td>
        </tr>
        <tr v-for="country in brand.countries" :key="country.countryCode">
            <td>{{ getCountryName(country.countryCode) }}</td>
            <td v-if="!editing[country.countryCode]">{{ country.termsCondition }}</td>
            <td v-else><input type="text" v-model="country.termsCondition" class="form-control"></td>
            <td v-if="!editing[country.countryCode]">
              <i class="fa fa-edit pointer" v-tooltip="'Edit GEO'" @click="editing[country.countryCode] = true; $forceUpdate()"></i>
              <i class="fa fa-remove pointer" v-tooltip="'Delete GEO'" @click="deleteGeo(country.countryCode)"></i>
            </td>
            <td v-else>
              <button class="btn btn-primary btn-sm" @click="editGeo(country)"><i class="fa fa-save"></i> Save</button>
              <button class="btn btn-danger btn-sm" @click="editing[country.countryCode] = false; $forceUpdate()"><i class="fa fa-remove"></i> Cancel</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { Browser } from '../../../../../mixins/helperMixin'
import countries from '../../../../../../static/countries.json'
import { BRAND_SET } from '../../../../../store/mutation-types'
import countryMixin from '../../../../../mixins/countryMixin'

export default {
  data () {
    return {
      newGeo: {},
      editing: {},
      countries,
      showAddGeo: false
    }
  },
  computed: {
    ...mapGetters({
      brand: 'getBrand'
    }),
    availableCountries () {
      return [
        { country_iso_code: 'GL', location_name: 'Global' },
        ...this.countries.filter(country =>
          !this.brand.countries.some(brandCountry =>
            brandCountry.countryCode === country.country_iso_code
          )
        )
      ]
    }
  },
  mixins: [countryMixin, Browser],

  mounted () {
    this.getLinks()
  },
  methods: {
    async editGeo (rec) {
      try {
        await axios.put(`/advertisers/brands/${this.brand.id}/country`, {
          countryCode: rec.countryCode,
          termsCondition: rec.termsCondition
        })
        this.newGeo = {}
        this.showAddGeo = false
        this.editing = {}
        await this.getLinks()
      } catch (e) {
        this.$toastr.error(e)
      }
    },
    async deleteGeo (countryCode) {
      try {
        await axios.delete(`/advertisers/brands/${this.brand.id}/country/${countryCode}`)
        this.$toastr.success('Country deleted successfully')
        this.getLinks()
      } catch (error) {
        this.$toastr.error('Failed deleting country', error)
      }
    },
    async getLinks () {
      try {
        let resp = await axios.get(`/advertisers/brands/${this.brand.id}`)
        this.$store.commit(BRAND_SET, resp.data)
      } catch (error) {
        this.$toastr.error('Failed loading brand', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Brand/Tabs/Geo.vue